import styled from 'styled-components';

export const Wrapper = styled.div`
	&.main-container {
		margin-top: 44px;
	}
	& .draftResultTitle {
		margin-bottom: 0;
		font-style: normal;
		font-weight: 400;
		font-size: 36px;
		line-height: 57px;
		color: #000000;
	}
	& .share-draft-wrap {
		margin: 24px 0;
	}
	& .share-draft {
		display: flex;
		align-items: center;
		gap: 20px;
		p {
			font-weight: 400;
			font-size: 20px;
			line-height: 30px;
			color: #000000;
		}
	}
  @media only screen and (max-width:1440px) {
    & .share-draft-wrap {
      width: 100%;
    }
    .share-draft {
      width: 100%;
    }
  }
    @media only screen and (max-width:1024px) {
    .share-draft  img{
      width: 34px;
      height: 34px;
    }
  }
  @media only screen and (max-width:768px) {
    gap: 8px;
    align-items: flex-start;
    flex-direction: column;
      .share-draft-wrap{
        margin: 0;
      }
    
  }
`;

export const DraftResultShare = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& .enter-draft-btn {
		margin: 0;
	}
  @media only screen and (max-width:1440px) {
    gap: 20px;
    .enter-draft-btn{
      padding: 12px;
      width: fit-content;
      white-space: nowrap;
    }
  }
  @media only screen and (max-width:768px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const ActionWrap = styled.div`
	display: flex;
	align-items: center;
	gap: 23px;
	margin-bottom: 5px;
	.downland-btn {
		display: flex;
		align-items: center;
		color: #004ea3;
		gap: 6px;
		font-weight: 600;
		font-size: 14px;
		line-height: 20px;
		text-align: center;
		cursor: pointer;
	}
	.downland-copy {
		display: flex;
		align-items: center;
		gap: 6px;
		font-weight: 600;
		font-size: 14px;
		line-height: 20px;
		text-align: center;
		color: #004ea3;
		cursor: pointer;
	}
  @media only screen and (max-width:1440px) {
    width: 100%
  }
`;

export const DraftConfigPlayersPositions = styled.section`
	margin-top: 25px;
	margin-bottom: 25px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 25px;
	height: 100%;
	overflow-x: auto;
`;

export const PlayersBoardContainer = styled.div`
	display: flex;
	flex-direction: column;
  @media only screen and (max-width:1400px) {
    width: 100%;
  }
`;

export const PlayersBoard = styled.div`
	background-image: url(${props => props.backImg || ''});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: bottom;
    height: 1390px;
	width: 700px;
	padding: 60px 20px;
	display: flex;
	flex-direction: column;
	.titleDiv {
		display: flex;
		gap: 20px;
	}
	
	.title {
		width: 100%;
		display: flex;
		justify-content: center;
		color: #bfb881;
		font-size: 44px;
		font-style: normal;
		font-weight: 700;
		margin-bottom: 80px;
		white-space: nowrap;
	}
	.player-name {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 21px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
		text-transform: uppercase;
		flex-wrap: wrap;
	}
	.row {
		display: flex;
		justify-content: space-between;
		width: 100%;
		gap: 30px;
	}
	table {
		width: 100%;
		border-collapse: separate;
	}
	td {
		padding-bottom: 40px;
	}
	.wrx-div {
		color: #ffce07;
	}
	.cb1-div {
		color: #fff;
	}
	.wrs-div {
		color: #ffce07;
	}
	.dflex1-div {
		color: #fff;
	}
	.lt-div {
		color: #ffce07;
	}
	.edge-div {
		color: #fff;
	}
	.lg-div {
		color: #ffce07;
	}
	.lb-div {
		color: #fff;
	}
	.rb-div {
		color: #ffce07;
	}
	.qb-div {
		color: #ffce07;
	}
	.c-div {
		color: #ffce07;
	}
	.dl1-div {
		color: #fff;
	}
	.s1-div {
		color: #fff;
	}
	.rg-div {
		color: #ffce07;
	}
	.dl2-div {
		color: #fff;
	}
	.rt-div {
		color: #ffce07;
	}
	.te-div {
		color: #ffce07;
	}
	.dflex3-div {
		color: #fff;
	}
	.dflex2-div {
		color: #fff;
	}
	.s2-div {
		color: #fff;
	}
	.wrz-div {
		color: #ffce07;
	}
	.cb2-div {
		color: #fff;
	}
  @media only screen and (max-width:1450px) {
    max-width: 700px;
    width: 100%;
  }
  @media only screen and (max-width:1400px) {
    max-width: 100%;
  }
  @media only screen and (max-width:768px) {
    padding: 24px 14px;
    height: 1300px;
    .title{
      white-space: unset;
      font-size: 30px;
    }
  }
  @media only screen and (max-width:700px) {
    padding: 24px 4px;
    height:1100px;
    .player-name {
      font-size: 13px;
    }
  }
  @media only screen and (max-width:550px) {
    .logoDiv img {
      width: 60px;
    }
  }
  @media only screen and (max-width:424px) {
    max-width: 450px;
    width: 450px;
  }
`;
